    // Klaviyo popup language auto-select (improved observer)
    function getCurrentLocale() {
        return window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en';
    }
    
(function() {
    
    function getKlaviyoLanguageLabel(locale) {
        switch (locale) {
            case 'es': return 'Español';
            case 'en': default: return 'English';
        }
    }

    function trySelectLanguage(form, attempt = 0) {
        const locale = getCurrentLocale();
        const label = getKlaviyoLanguageLabel(locale);
        const radio = form.querySelector(`input[type="radio"][aria-label="${label}"]`);
        if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            // console.log('Klaviyo language selected:', label);
        } else if (attempt < 10) {
            setTimeout(() => trySelectLanguage(form, attempt + 1), 100);
        } else {
            // console.log('Klaviyo form found, but no radio for', label, 'after multiple attempts');
        }
        // After language selection, run translation if needed
        translateKlaviyoForm(form, locale);

        // Add observer to translate on form content change
        if (!form._klaviyoTranslationObserver) {
            const observer = new MutationObserver(() => {
                translateKlaviyoForm(form, locale);
            });
            observer.observe(form, { childList: true, subtree: true });
            form._klaviyoTranslationObserver = observer;
        }
    }

    function handleKlaviyoPopup(mutationsList) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        // Check if the node itself is a form
                        if (node.matches && node.matches('form[data-testid^="klaviyo-form-"]')) {
                            // console.log('Klaviyo popup form detected (direct node)', node);
                            trySelectLanguage(node);
                        }
                        // Or if it contains the form as a descendant
                        const forms = node.querySelectorAll ? node.querySelectorAll('form[data-testid^="klaviyo-form-"]') : [];
                        forms.forEach(form => {
                            // console.log('Klaviyo popup form detected (descendant)', form);
                            trySelectLanguage(form);
                        });
                    }
                });
            }
        }
    }

    // Observe the entire document for robustness
    const klaviyoPopupObserver = new MutationObserver(handleKlaviyoPopup);
    klaviyoPopupObserver.observe(document.documentElement, { childList: true, subtree: true });

    // Run once on page load
    document.querySelectorAll('form[data-testid^="klaviyo-form-"]').forEach(form => {
        // console.log('Klaviyo popup form detected (on load)', form);
        trySelectLanguage(form);
    });
    
    // Klaviyo Back-in-Stock Form Translation
    function translateKlaviyoForm(form, locale) {
        if (locale !== 'es') return;
        if (!form) return;

        // Translate main heading (pre-submit and post-submit)
        const heading = form.querySelector('h1 span');
        if (heading) {
            const text = heading.textContent.trim();
            if (text === 'NOTIFY ME WHEN AVAILABLE') {
                heading.textContent = 'AVÍSAME CUANDO ESTÉ DISPONIBLE';
            } else if (text === "YOU'RE ALL SET!") {
                heading.textContent = '¡TODO LISTO!';
            }
        }

        // Translate subheading (pre-submit and post-submit)
        const subheading = form.querySelector('div[id^="rich-text-"] > div > span, div[id^="rich-text-"] > div > div > span');
        if (subheading) {
            const text = subheading.textContent.trim();
            if (text.startsWith("We'll send you an email")) {
                subheading.textContent = 'Te enviaremos un correo electrónico cuando este producto vuelva a estar disponible.';
            } else if (text === 'Keep an eye out for a back-in-stock message.') {
                subheading.textContent = 'Estate atento a un mensaje de disponibilidad.';
            }
        }

        // Translate label
        const label = form.querySelector('label[for^="email_"]');
        if (label && label.textContent.trim() === 'Email') {
            label.textContent = 'Correo electrónico';
        }

        // Translate input placeholder
        const input = form.querySelector('input[type="email"]');
        if (input && input.placeholder === 'Enter your email') {
            input.placeholder = 'Correo electrónico';
        }

        // Translate button
        const button = form.querySelector('button[type="button"]');
        if (button && button.textContent.trim() === 'NOTIFY ME') {
            button.textContent = 'AVÍSAME';
        }
    }
})();

(function() {
    // Hide Yotpo widgets with zero reviews
    //
    // Yotpo renders its star ratings asynchronously, so we only learn the review
    // count once the widget has been filled in. Hiding zero-review widgets at
    // that point made them flash, so the product card widgets start out
    // invisible in CSS (see the data-yotpo-reviews rules in theme.css) and are
    // only revealed once the count is known. Resolving happens straight from the
    // MutationObserver callback, which runs before the browser paints, so the
    // "0 Reviews" state is never visible.
    const WIDGET_SELECTOR = '.yotpo-widget-instance';
    const REVIEW_TEXT_SELECTOR = '.yotpo-sr-bottom-line-text';
    const COUNT_ATTRIBUTE = 'data-yotpo-reviews';
    // Fallback polling for widgets Yotpo renders in a way the observer misses.
    const SWEEP_INTERVAL = 500;
    const SWEEP_TIMEOUT = 5000;

    let sweepTimer = null;
    let sweepDeadline = 0;

    // The Q&A widget (snippets/yotpo-qna.liquid) has no review count. Its question
    // count feeds the buy box link instead (snippets/yotpo-qna-link.liquid).
    const QNA_WIDGET_ID = 'yotpo-qna';
    const QNA_SUMMARY_SELECTOR = '.yotpo-header-summary';
    const QNA_EMPTY_SELECTOR = '.yotpo-qna-empty-state';
    const QNA_LINK_SELECTOR = '[data-yotpo-qna-link]';
    const QNA_COUNT_ATTRIBUTE = 'data-yotpo-questions';

    function isQnaWidget(widget) {
        return widget.id === QNA_WIDGET_ID;
    }

    // Widgets inside .product-info stay visible whatever their review count is.
    function isManaged(widget) {
        return !isQnaWidget(widget) && widget.closest('.product-info') === null;
    }

    function isPending(widget) {
        if (isQnaWidget(widget)) {
            return !widget.hasAttribute(QNA_COUNT_ATTRIBUTE);
        }
        return isManaged(widget) && !widget.hasAttribute(COUNT_ATTRIBUTE);
    }

    // Returns null while Yotpo still hasn't rendered the questions.
    function readQuestionCount(widget) {
        const summary = widget.querySelector(QNA_SUMMARY_SELECTOR);
        const match = summary ? summary.textContent.match(/(\d+)/) : null;
        if (match) {
            return parseInt(match[1], 10);
        }
        return widget.querySelector(QNA_EMPTY_SELECTOR) ? 0 : null;
    }

    // Swaps "Ask a question" for "Questions & Answers (#)" once there are questions.
    function updateQnaLinks(count) {
        document.querySelectorAll(QNA_LINK_SELECTOR).forEach(link => {
            const template = count > 0 ? link.dataset.questionsText : link.dataset.askText;
            if (!template) return;
            const text = template.replace('[count]', count);
            if (link.textContent.trim() !== text) {
                link.textContent = text;
            }
        });
    }

    // Returns true once the widget's question count is known.
    function resolveQnaWidget(widget) {
        const count = readQuestionCount(widget);
        if (count === null) {
            return false;
        }
        // Only write on change, otherwise this re-triggers the observer forever.
        if (widget.getAttribute(QNA_COUNT_ATTRIBUTE) !== String(count)) {
            widget.setAttribute(QNA_COUNT_ATTRIBUTE, String(count));
        }
        updateQnaLinks(count);
        return true;
    }

    // Returns null while Yotpo still hasn't rendered a review count.
    function readReviewCount(widget) {
        const reviewText = widget.querySelector(REVIEW_TEXT_SELECTOR);
        if (!reviewText) {
            return null;
        }
        const match = reviewText.textContent.match(/(\d+)/);
        return match ? parseInt(match[1], 10) : null;
    }

    function pluralizeReviewText(widget, count) {
        if (getCurrentLocale() !== 'es') {
            return;
        }
        const reviewText = widget.querySelector(REVIEW_TEXT_SELECTOR);
        const pluralized = count === 1 ? '1 Reseña' : `${count} Reseñas`;
        if (reviewText && reviewText.textContent.trim() !== pluralized) {
            reviewText.textContent = pluralized;
        }
    }

    function setReviewCount(widget, value) {
        // Only write on change, otherwise this re-triggers the observer forever.
        if (widget.getAttribute(COUNT_ATTRIBUTE) !== value) {
            widget.setAttribute(COUNT_ATTRIBUTE, value);
        }
    }

    // Returns true once the widget's review count is known.
    function resolveWidget(widget) {
        if (isQnaWidget(widget)) {
            return resolveQnaWidget(widget);
        }
        const count = readReviewCount(widget);
        if (count === null) {
            return false;
        }
        // Translate before revealing so the English text never shows either.
        pluralizeReviewText(widget, count);
        if (isManaged(widget)) {
            setReviewCount(widget, String(count));
        }
        return true;
    }

    function sweepWidgets() {
        const pending = [];
        document.querySelectorAll(WIDGET_SELECTOR).forEach(widget => {
            if (!resolveWidget(widget) && isPending(widget)) {
                pending.push(widget);
            }
        });

        const timedOut = Date.now() >= sweepDeadline;
        if (timedOut) {
            // Yotpo never gave these a review count -- reveal them rather than
            // leave them hidden for good.
            pending.filter(isManaged).forEach(widget => setReviewCount(widget, 'unknown'));
        }
        if (timedOut || pending.length === 0) {
            clearInterval(sweepTimer);
            sweepTimer = null;
        }
    }

    function watchPendingWidgets() {
        sweepDeadline = Date.now() + SWEEP_TIMEOUT;
        if (sweepTimer === null) {
            sweepTimer = setInterval(sweepWidgets, SWEEP_INTERVAL);
        }
    }

    const yotpoObserver = new MutationObserver((mutationsList) => {
        const widgets = new Set();

        mutationsList.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;
                const widget = node.closest(WIDGET_SELECTOR);
                if (widget) {
                    // Yotpo rendered its markup into an existing widget
                    widgets.add(widget);
                } else {
                    // New markup that brings its own widgets, e.g. filtered
                    // product grids or recently viewed products
                    node.querySelectorAll(WIDGET_SELECTOR).forEach(added => widgets.add(added));
                }
            });
        });

        if (widgets.size === 0) return;

        widgets.forEach(resolveWidget);
        if (Array.from(widgets).some(isPending)) {
            watchPendingWidgets();
        }
    });

    yotpoObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });

    // Widgets already in the DOM when this script runs, plus a check after
    // DOMContentLoaded in case widgets are rendered late
    watchPendingWidgets();
    sweepWidgets();
    document.addEventListener('DOMContentLoaded', () => {
        watchPendingWidgets();
        sweepWidgets();
    });

    document.addEventListener('recently-viewed-products:loaded', () => {
        setTimeout(() => {
            window.yotpoWidgetsContainer?.initWidgets?.();
        }, 0);
    });
})();


// live chat activation links
addEventListener("DOMContentLoaded", (event) => {
    const chatActivationLinks = document.querySelectorAll('a[href="#chat"]')
    chatActivationLinks.forEach((chatActivationLink) => {
        chatActivationLink.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            document.getElementById('ShopifyChat')?.shadowRoot?.querySelector('button.chat-toggle')?.click()
        })
    })
})

const chatObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
                if (
                    node.nodeType === 1 && node.id === 'ShopifyChat'
                ) {
                    const tryInject = () => {
                        const shadow = node.shadowRoot
                        if (shadow) {
                            const style = document.createElement('style')
                            style.textContent = `
                                .chat-toggle, .chat-app--close-button {
                                    border: 1px solid #fff !important
                                }
                            `
                            shadow.appendChild(style)

                            chatObserver.disconnect()
                        } else {
                            setTimeout(tryInject, 100)
                        }
                    }

                    tryInject()
                    chatObserver.disconnect()
                }
            }
        }
    }
})

chatObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
});

(function() {
    function onSwymLoadCallback(swat) {
        let listener = function(e) {
            document.dispatchEvent(new CustomEvent("cart:refresh"))
        };

        swat.evtLayer.addEventListener('sw:movedToCartfromSFL', listener)
        swat.evtLayer.addEventListener('sw:movedAllToCartAllFromSFL', listener)
        swat.evtLayer.addEventListener('sw:addedToCartFromSharedSFL', listener)
        swat.evtLayer.addEventListener('sw:addedAllToCartFromSharedSFL', listener)
        swat.evtLayer.addEventListener('sw:storeAddedToCart', listener)
        swat.evtLayer.addEventListener('sw:storeRemovedFromCart', listener)
        swat.evtLayer.addEventListener('sw:addedtocart', listener)
        swat.evtLayer.addEventListener('sw:addedalltocart', listener)
        swat.evtLayer.addEventListener('sw:removedfromcart', listener)
    }  
    if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(onSwymLoadCallback)
})()

// Klaviyo BIS Button Translation in buy-buttons
function translateKlaviyoBisButton(button, locale) {
    if (locale !== 'es') return;
    if (button && button.textContent.trim() === 'NOTIFY ME WHEN BACK IN STOCK') {
        button.textContent = 'AVÍSAME CUANDO ESTÉ DISPONIBLE';
    }
}

function startKlaviyoBisButtonObserver() {
    const locale = getCurrentLocale();
    const buyButtons = document.querySelector('buy-buttons.buy-buttons');
    if (!buyButtons) return;

    // Translate any existing button on load
    const bisButton = buyButtons.querySelector('#klaviyo-bis-button-container button[type="button"]');
    if (bisButton) {
        translateKlaviyoBisButton(bisButton, locale);
    }

    // Observe for future additions
    const bisObserver = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check all added nodes
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        // Direct button container
                        if (node.id === 'klaviyo-bis-button-container') {
                            const btn = node.querySelector('button[type="button"]');
                            if (btn) translateKlaviyoBisButton(btn, locale);
                        }
                        // Or descendant button
                        const btns = node.querySelectorAll ? node.querySelectorAll('#klaviyo-bis-button-container button[type="button"]') : [];
                        btns.forEach(btn => translateKlaviyoBisButton(btn, locale));
                    }
                });
                // Also check the container itself after mutation
                const btn = buyButtons.querySelector('#klaviyo-bis-button-container button[type="button"]');
                if (btn) translateKlaviyoBisButton(btn, locale);
            }
        }
    });
    bisObserver.observe(buyButtons, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', startKlaviyoBisButtonObserver);


// Deferred product list (sections/related-products.liquid)
//
// Liquid's all_products lookup is capped at 20 unique products per page render. On product pages
// the variant picker resolves custom.variation_products first, so a large variation group can
// exhaust the cap before "You may also like" runs and its remaining handles come back empty.
//
// Re-requesting the section on its own via the Section Rendering API gives it a fresh budget,
// because nothing else on the page is competing for it. The section adds the `defer` attribute
// only when it detected unresolved handles, so healthy pages never make this request.
(function () {
    if (window.customElements.get('deferred-product-list')) return;

    class DeferredProductList extends HTMLElement {
        connectedCallback() {
            // Fetch once per element. The response contains this same element, but it is parsed
            // detached and only its children are imported, so this never recurses.
            if (this._isLoaded || !this.hasAttribute('defer')) return;
            this._isLoaded = true;
            this._load();
        }

        async _load() {
            const url = this.getAttribute('url');
            if (!url) return;

            this.setAttribute('loading', '');

            try {
                const response = await fetch(url, { priority: 'low' });
                if (!response.ok) throw new Error(`Section request failed: ${response.status}`);

                const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
                const fresh = doc.querySelector('deferred-product-list');

                if (fresh && fresh.childElementCount > 0) {
                    this.replaceChildren(...document.importNode(fresh, true).childNodes);
                } else if (this.childElementCount === 0) {
                    // Nothing here and nothing to show — drop the empty section rather than
                    // leaving a heading above an empty carousel.
                    this.closest('.shopify-section')?.remove();
                }
            } catch (error) {
                // Keep whatever the server rendered; an incomplete list beats an empty one.
                console.warn('[deferred-product-list]', error);
            } finally {
                this.removeAttribute('loading');
            }
        }
    }

    window.customElements.define('deferred-product-list', DeferredProductList);
})();


// Predictive Search: Close on outside click or Escape key
(function() {
  const predictiveSearch = document.querySelector('.header__search-form .predictive-search:not([aria-controls="search-drawer"])');
  if (!predictiveSearch) return;

    function isVisible() {
        if (predictiveSearch.offsetParent === null || predictiveSearch.style.display === 'none') {
            return false;
        }
        // Check if results slot has opacity 1
        const resultsSlot = predictiveSearch.querySelector('[slot="results"]');
        if (resultsSlot) {
            const computedStyle = window.getComputedStyle(resultsSlot);
            return computedStyle.opacity === '1';
        }
        return true;
    }

  function closePredictiveSearch() {
    if (typeof predictiveSearch._onSearchCleared === 'function') {
      predictiveSearch._onSearchCleared();
    }
  }

  function handleClick(event) {
    if (!isVisible()) return;
    console.log('Click detected, checking if outside predictive search');
    if (!predictiveSearch.contains(event.target)) {
      closePredictiveSearch();
    }
  }

  function handleKeydown(event) {
    if (!isVisible()) return;
    if (event.key === 'Escape') {
      closePredictiveSearch();
    }
  }

  document.addEventListener('mousedown', handleClick);
  document.addEventListener('keydown', handleKeydown);
})();
// SKU Decorator: auto-links SKU references in feature bullets and product descriptions
// using the compatible_items metafield map embedded by sku-decorator.liquid
(function () {
  function initSkuDecorator() {
    var dataEl = document.getElementById('sku-decorator-data');
    if (!dataEl) return;

    var skuMap;
    try {
      skuMap = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var skus = Object.keys(skuMap);
    if (!skus.length) return;

    // The current product's own key (its handle, upcased) — don't self-link it on this page.
    var currentSku = (dataEl.getAttribute('data-current-sku') || '').trim();

    // Longest first so a longer SKU (e.g. 10636Q-18) is tried before a shorter one (e.g. 10636Q)
    skus.sort(function (a, b) { return b.length - a.length; });

    function escapeRegex(s) {
      return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // Match exact SKUs only. Negative lookahead prevents matching a base SKU (e.g. 10636Q)
    // inside a suffixed variant (e.g. 10636Q-18) which is a different product.
    var pattern = new RegExp(
      '\\b(' + skus.map(escapeRegex).join('|') + ')(?!-\\w)\\b',
      'g'
    );

    function resolveUrl(matched) {
      if (currentSku && matched === currentSku) return null;
      return skuMap[matched] || null;
    }

    function decorateTextNode(textNode) {
      var text = textNode.nodeValue;
      pattern.lastIndex = 0;
      if (!pattern.test(text)) return;
      pattern.lastIndex = 0;

      var frag = document.createDocumentFragment();
      var lastIndex = 0;
      var match;

      while ((match = pattern.exec(text)) !== null) {
        var matched = match[1];
        var url = resolveUrl(matched);
        if (!url) continue;

        if (match.index > lastIndex) {
          frag.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
        }

        var a = document.createElement('a');
        a.href = url;
        a.textContent = matched;
        a.className = 'sku-link link';
        frag.appendChild(a);
        lastIndex = match.index + matched.length;
      }

      if (!frag.childNodes.length) return;

      if (lastIndex < text.length) {
        frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      }

      textNode.parentNode.replaceChild(frag, textNode);
    }

    function decorateContainer(container) {
      var walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            var parent = node.parentNode;
            while (parent && parent !== container) {
              if (parent.nodeName === 'A') return NodeFilter.FILTER_REJECT;
              parent = parent.parentNode;
            }
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      var nodes = [];
      var node;
      while ((node = walker.nextNode())) nodes.push(node);
      nodes.forEach(decorateTextNode);
    }

    document.querySelectorAll('[data-sku-decorator]').forEach(decorateContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkuDecorator);
  } else {
    initSkuDecorator();
  }
})();

/**
 * Scroll to the top of the product grid when a collection pagination link is
 * clicked.
 *
 * The pagination is injected dynamically by qep-filter-app.js, so we don't
 * bind directly to the links. Instead we delegate the click from the document
 * and filter for active pagination items. We target #qep-product-grid rather
 * than the sort bar because the sort bar isn't visible on mobile.
 */
(function () {
  function scrollToProductGrid() {
    var target = document.getElementById('qep-product-grid');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.pagination__item:not(.pagination__item--disabled)');
    if (!link) return;
    // Let qep-filter-app handle the navigation/content swap, then scroll.
    scrollToProductGrid();
  });
})();

window.addEventListener('_mpr_submit_success', function (e) {
  var data = e.detail || {};
  var redirect = data.response && data.response.redirect;

  // No redirect configured — let the warranty app show its own success modal.
  if (!redirect) return;

  // Take over the navigation so we can localize the destination and skip the
  // app's success modal (which would otherwise flash before its own redirect).
  e.preventDefault();

  // The app's configured redirect is locale-agnostic (e.g. "/pages/warranty-complete"),
  // so prepend the active locale prefix — matching the convention used elsewhere in
  // this file — to keep Spanish shoppers on the localized page. Shopify resolves the
  // English page handle under the locale prefix to its translated URL automatically.
  var localePrefix = window.Shopify && Shopify.locale && Shopify.locale !== 'en'
    ? '/' + Shopify.locale
    : '';

  // Only prefix root-relative paths (not absolute or protocol-relative URLs) that
  // don't already carry the locale prefix.
  if (localePrefix && /^\/(?!\/)/.test(redirect) && redirect.indexOf(localePrefix + '/') !== 0) {
    redirect = localePrefix + redirect;
  }

  // Hide the success modal in case it renders before navigation begins.
  var hideModalStyle = document.createElement('style');
  hideModalStyle.textContent = '.ReactModalPortal { display: none !important; }';
  document.head.appendChild(hideModalStyle);

  window.location.href = redirect;
});

/**
 * Open external links in a new tab, site-wide.
 *
 * Any anchor pointing at a different hostname than the page it sits on gets
 * target="_blank" and rel="noreferrer noopener". Shopify CDN URLs (the catalog
 * and brand-guidelines PDFs) count as external under this rule, which is the
 * intent — a download should not replace the page the visitor was reading.
 *
 * Details worth knowing before editing:
 *
 *  - The hostname is read off the anchor element rather than parsed out of the
 *    href, so relative, protocol-relative and absolute URLs all resolve the
 *    same way, and the rule follows the store onto dev/preview domains without
 *    a hostname hardcoded here.
 *  - mailto:, tel: and every other non-http(s) scheme are left untouched.
 *  - Anchors that already declare a target keep it, so the per-block "Open in a
 *    new tab" settings still win and any deliberate target="_self" is honored.
 *  - Markup can opt a link out with the data-no-external-target attribute.
 *  - Links injected after load (filtered collection grid, cart drawer, quick
 *    buy) are covered by the observer rather than a one-shot pass on load.
 */
(function () {
  var SKIP_ATTRIBUTE = 'data-no-external-target';
  var REL_TOKENS = ['noopener'];

  // Treat apex and www as the same site so shopqep.com links aren't flagged
  // external while browsing www.shopqep.com, or the other way around.
  function normalizeHost(hostname) {
    return hostname.replace(/^www\./i, '').toLowerCase();
  }

  function isExternal(link) {
    if (link.protocol !== 'http:' && link.protocol !== 'https:') return false;
    if (!link.hostname) return false;

    return normalizeHost(link.hostname) !== normalizeHost(window.location.hostname);
  }

  function decorateLink(link) {
    if (link.hasAttribute(SKIP_ATTRIBUTE)) return;
    if (!isExternal(link)) return;

    // A target already on the markup wins, so the per-block "Open in a new tab"
    // settings and any deliberate target="_self" stay in control.
    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
    }

    // Only links that actually open a new tab need the opener/referrer guard —
    // but they all need it, including the ones Liquid already marked up, which
    // is why this runs outside the branch above.
    if (link.getAttribute('target') !== '_blank') return;

    // Add to whatever rel the link already carries (nofollow, sponsored, ...)
    // instead of replacing it.
    var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    var missing = REL_TOKENS.filter(function (token) {
      return rel.indexOf(token) === -1;
    });

    if (missing.length === 0) return;

    link.setAttribute('rel', rel.concat(missing).join(' '));
  }

  function decorateTree(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches('a[href]')) decorateLink(root);
    root.querySelectorAll('a[href]').forEach(decorateLink);
  }

  function initExternalLinks() {
    decorateTree(document.body);

    // Only the added subtrees are walked, so this stays cheap on pages that
    // churn the DOM (collection filtering, cart updates).
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(decorateTree);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExternalLinks);
  } else {
    initExternalLinks();
  }
})();
